// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from 'firebase/database';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD7IxjZkbboeF62O6rNzLzy8pNdw2Dv2iE",
  authDomain: "sourcewiz-4dd51.firebaseapp.com",
  projectId: "sourcewiz-4dd51",
  storageBucket: "sourcewiz-4dd51.appspot.com",
  messagingSenderId: "281296339348",
  appId: "1:281296339348:web:9e7b2edbcdb56f22338f81",
  measurementId: "G-GF5MVHKQSK",
  databaseURL: "https://sourcewiz-4dd51-default-rtdb.asia-southeast1.firebasedatabase.app/"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app);



export { app, analytics,db };